import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    TandC_for: Yup.string().required("please choose section"),
    TandC_description: Yup.string().required("please enter description")
  }),
  validateOnMount: true,
  mapPropsToValues: props => ({
    TandC_for: "Merchant",
    TandC_description: ""
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
